"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.newMeasureSortSuggestion = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
function newMeasureSortSuggestion(identifier, attributeLocators) {
    if (attributeLocators === void 0) { attributeLocators = []; }
    var locators = sdk_model_1.newMeasureSort(identifier, "asc", attributeLocators).measureSortItem.locators;
    return {
        type: "measureSort",
        locators: locators,
    };
}
exports.newMeasureSortSuggestion = newMeasureSortSuggestion;
//# sourceMappingURL=SortConfig.js.map